import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Table,
} from "reactstrap";
import { connect } from "react-redux";
import { profilePicValidityCheck } from "../../../../utils/constants";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { toastContainer } from "../../../../utils/toast";
import * as actionCreators from "../../../../modules/actions";

const SendSMSTextQuestionsModal = ({
  open,
  onClose,
  trivia,
  user,
  orgChangeSuccess,
  editCurrentTriviaShareData,
}) => {
  const [sendToDroppedUsers, setSendToDroppedUsers] = useState(null);

  const [showDroppedUsersAlert, setShowDroppedUsersAlert] = useState(false);

  const [trivvyResults,setTrivvyResults] = useState([]);

  useEffect(() => {
    axios.post(url.getTriviaSubmissions(trivia._id)).then(({data})=>{
      setTrivvyResults(data.data)
    })
  }, []);

  const allUsersTakenTrivvy=()=>{
    if(trivvyResults && trivvyResults.length){
       const trivvyResultUsersIds = trivvyResults.map(x => x.userId ? x.userId.toString():null).filter(k => k);
      
       const usersTakenTrivvy = smsUsers.filter(x => x.userId && trivvyResultUsersIds.includes(x.userId.toString()));
       return usersTakenTrivvy.length == smsUsers.length
    }else{
      return false;
    }
  }
  

  const smsUsers =
    sendToDroppedUsers == "YES"
      ? trivia
        ? trivia.sharedWithUsers.filter((x) => x.mobileNumber)
        : []
      : trivia
      ? trivia.sharedWithUsers.filter((x) => x.mobileNumber && !x.smsDate)
      : [];

  const noOfSMSToBeSent = trivia
    ? smsUsers.length * trivia.questions.length
    : 0;

  const remainingSMSLimit =
    user && user.profile && user.profile.organizationId
      ? user.profile.organizationId.smsLimit -
        user.profile.organizationId.totalSmsSent
      : 0;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const sendQuestionsAsTexts = () => {
    axios
      .post(url.shareTriviaAsTextSurvey, {
        triviaId: trivia._id,
        users: smsUsers,
        sendToDroppedUsers: sendToDroppedUsers === "YES",
      })
      .then(({ data }) => {
        editCurrentTriviaShareData({
          sharedWithUsers: data.data.updateTriviaShareUsers,
          privacy:trivia.privacy
        });
        toastContainer("SMS sent successfully", "success");
        orgChangeSuccess({
          totalSmsSent: data.data.orgEmailSMSCountsUpdate.totalSmsSent,
        });
        onClose();
      })
      .catch((error) => {
        // toastContainer("Error while sending", "error");
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  return (
    <div>
      {smsUsers.length ? (
        <div>
          {remainingSMSLimit <= noOfSMSToBeSent ? (
            <Alert color="error">
              You dont have sufficient SMS balance to send trivvy questions as
              text
            </Alert>
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        ""
      )}

      {smsUsers.length > 0 && sendToDroppedUsers != null && (
        <Alert>
          {smsUsers.length} {smsUsers.length > 1 ? "users" : "user"} will
          receive Trivvy questions as SMS texts. <br />
          Total {noOfSMSToBeSent} SMS texts (1 text per question) will be sent.
          <div className="d-flex mt-3">
            <Button
              color="success"
              onClick={() => {
                setSendToDroppedUsers(null);
                sendQuestionsAsTexts();
              }}
              disabled={remainingSMSLimit < noOfSMSToBeSent}
            >
              Send
            </Button>{" "}
            <Button
              color="danger"
              className="ml-3"
              onClick={() => {
                setSendToDroppedUsers(null);
                setShowDroppedUsersAlert(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </Alert>
      )}

      {showDroppedUsersAlert && (
        <div>
          {trivia.sharedWithUsers.filter((x) => x.smsDate).length ? (
            allUsersTakenTrivvy()?  <Alert color="warning">
            This Trivvy has already been sent to the mobile number{trivia.sharedWithUsers
              .filter((x) => x.smsDate && x.mobileNumber).length > 1 ? "s":""}
            {trivia.sharedWithUsers
              .filter((x) => x.smsDate && x.mobileNumber)
              .map((k) => k.mobileNumber)
              .join(",")}
            
          </Alert> :  <Alert color="warning">
            This Trivvy has already been sent to the mobile number{trivia.sharedWithUsers
              .filter((x) => x.smsDate && x.mobileNumber).length > 1 ? "s":""}
            {trivia.sharedWithUsers
              .filter((x) => x.smsDate && x.mobileNumber)
              .map((k) => k.mobileNumber)
              .join(",")}
            <br />
          
            <div className="d-flex mt-3">
              <Button
                color="success"
                onClick={() => {
                  setSendToDroppedUsers("YES");
                  setShowDroppedUsersAlert(false);
                }}
              >
               Re-Send again
              </Button>{" "}
              <Button
                color="danger"
                className="ml-3"
                onClick={() => {
                  setSendToDroppedUsers("NO");
                  setShowDroppedUsersAlert(false);
                }}
              >
                Dont resend
              </Button>
            </div>
          </Alert>
           
          ) : (
            ""
          )}
        </div>
      )}

      {showDroppedUsersAlert || sendToDroppedUsers != null ? (
        ""
      ) : (
        <Button
          className="trivia-action-button-main mb-4"
          onClick={() => {
            if (trivia.sharedWithUsers.filter((x) => x.smsDate).length) {
              setShowDroppedUsersAlert(true);
            } else {
              setSendToDroppedUsers("NO");
            }
          }}
        >
          Send Questions as SMS Texts
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendSMSTextQuestionsModal);
